// Legacy e-clinicx — user sign-up / sign-in / OTP flows are disabled.
// The screens (SignIn, SignUp, Verification) are unreachable: their routes and
// imports are commented out in main/routes.js.
//
// This file still exports a saga because rootSaga.js registers it. Keeping the
// empty generator means rootSaga does not need to change when these flows come
// back — just uncomment the block below and the `authApi` block in
// main/services/index.js.

// import { call, put, takeEvery } from 'redux-saga/effects'
// import {
//   userSignUp,
//   userSignUpFailed,
//   userSignUpSuccess,
//   userSignIn,
//   userSignInSuccess,
//   userSignInFailed,
//   userVerification,
//   userVerificationFailed,
//   userVerificationSuccess,
// } from './slice'
// import { API } from 'src/main/services'

// function* signUp({ payload }) {
//   try {
//     const response = yield call(API.authApi.signUpUser, payload)
//     if (
//       response?.status === 200 &&
//       response?.data &&
//       response?.data?.code === 0 &&
//       response?.data?.error === false
//     ) {
//       yield put(userSignUpSuccess({ payload: response?.data }))
//     } else {
//       yield put(userSignUpFailed({ message: response?.data?.message }))
//     }
//   } catch (error) {
//     yield put(userSignUpFailed({ message: error?.message }))
//   }
// }

// function* signIn({ payload }) {
//   try {
//     const response = yield call(API.authApi.signInUser, payload)
//     if (
//       response?.status === 200 &&
//       response?.data &&
//       response?.data?.code === 0 &&
//       response?.data?.error === false
//     ) {
//       yield put(userSignInSuccess({ payload: response?.data }))
//     } else {
//       yield put(userSignInFailed({ message: response?.data?.message }))
//     }
//   } catch (error) {
//     yield put(userSignInFailed({ message: error?.message }))
//   }
// }

// function* verification({ payload }) {
//   try {
//     const response = yield call(API.authApi.userVerification, payload)
//     if (
//       response?.status === 200 &&
//       response?.data &&
//       response?.data?.code === 0 &&
//       response?.data?.error === false
//     ) {
//       yield put(userVerificationSuccess({ payload: response?.data }))
//     } else {
//       yield put(userVerificationFailed({ message: response?.data?.message }))
//     }
//   } catch (error) {
//     yield put(userVerificationFailed({ message: error?.message }))
//   }
// }

function* authSaga() {
  // yield takeEvery(userSignUp, signUp)
  // yield takeEvery(userSignIn, signIn)
  // yield takeEvery(userVerification, verification)
}

export default authSaga
